export default __webpack_public_path__ + "static/media/withdrawIcons.1ab26da4.png";